import { useEffect } from "react";
import { supabase } from "../services/supabase";

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN;

const LogoutPage = () => {
  useEffect(() => {
    (async () => {
      await supabase.auth.signOut();
      await fetch(`${API_DOMAIN}/api/logout`, {
        method: "POST",
        credentials: "include",
      });
      window.location.replace("/");
    })();
  }, []);
  return null;
};

export default LogoutPage;
